import { render, staticRenderFns } from "./PrazosRecursaisDialog.vue?vue&type=template&id=51ec9292&scoped=true&"
import script from "./PrazosRecursaisDialog.vue?vue&type=script&lang=js&"
export * from "./PrazosRecursaisDialog.vue?vue&type=script&lang=js&"
import style0 from "./PrazosRecursaisDialog.vue?vue&type=style&index=0&id=51ec9292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ec9292",
  null
  
)

export default component.exports